export const isMainInventoryLocation = (location) => Boolean(location?.is_main)
  || String(location?.code || "").trim().toUpperCase() === "MAIN";

// Evaluate the configured locations before permissions: access to Main alone
// must never make it a receiving destination when real locations exist.
export function isUnavailableMainLocation(locationId, locations = [], savedMainLocationIds = []) {
  if (!locationId) return false;
  const location = locations.find((entry) => String(entry.id) === String(locationId));
  const isMain = isMainInventoryLocation(location) || savedMainLocationIds.some((id) => String(id) === String(locationId));
  return isMain && (location?.is_receiving_destination === false
    || locations.some((entry) => entry.is_active !== false && !isMainInventoryLocation(entry)));
}
